// PlatformFormUI.tsx
import { Box, Grid, InputLabel, MenuItem, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import ArgonSelect from "components/ArgonSelect";

interface PlatformFormUIProps {
  platformName: string;
  platformType: "retail" | "service";
  onPlatformNameChange: (value: string) => void;
  onPlatformTypeChange: (value: "retail" | "service") => void;
  ragioneSociale?: string;
  onRagioneSocialeChange?: (value: string) => void;
}

export const SafeArgonSelect = ArgonSelect as any;

const PlatformFormUI: React.FC<PlatformFormUIProps> = ({
  platformName,
  platformType,
  onPlatformNameChange,
  onPlatformTypeChange,
  ragioneSociale,
  onRagioneSocialeChange,
}) => {
  // Ensure platformType is always a valid option
  useEffect(() => {
    // If platformType is retail (which is not available), default to service
    if (platformType === "retail") {
      onPlatformTypeChange("service");
    }
  }, [platformType, onPlatformTypeChange]);

  // Validate the platformType before rendering
  const validPlatformType = platformType === "service" ? platformType : "service";
  const { t } = useTranslation();
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        {t("Il tuo business")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("La tua ragione sociale")}
          </InputLabel>
          <TextField
            fullWidth
            value={ragioneSociale}
            onChange={(e) => onRagioneSocialeChange(e.target.value)}
            label={t("Scrivi qui la tua ragione sociale")}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("il nome della tua attività")}
          </InputLabel>
          <TextField
            fullWidth
            value={platformName}
            onChange={(e) => onPlatformNameChange(e.target.value)}
            label={t("Scrivi qui il nome della tua attività")}
          />
        </Grid>
        {/*<Grid item xs={12}>
                    <InputLabel required sx={{ mb: 1 }}>
                        {t("onboarding.businessType")}
                    </InputLabel>
                    <TextField
                        select
                        fullWidth
                        value={validPlatformType}
                        onChange={(e) => onPlatformTypeChange(e.target.value as "retail" | "service")}
                    >
                        <MenuItem value="service">{t("onboarding.services")}</MenuItem>
                        <MenuItem value="retail" disabled>Retail (coming soon!)</MenuItem>
                    </TextField>
                </Grid>*/}
      </Grid>
    </Box>
  );
};

export default PlatformFormUI;
